import { __assign, __awaiter, __extends, __generator } from "tslib";
import React, { Component } from 'react';
// Components.
import { Modal } from '../Modal';
import { Calendar } from './Calendar';
var MoveDropModal = /** @class */ (function (_super) {
    __extends(MoveDropModal, _super);
    function MoveDropModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            deliveryWindows: [],
            showDeliveryModal: false,
        };
        _this.onSelectSlot = function (slot) {
            var event = __assign({}, _this.state.currentDrop);
            event.start = slot;
            event.end = slot;
            _this.setState({ currentDrop: event });
        };
        _this.moveDrop = function () { return __awaiter(_this, void 0, void 0, function () {
            var currentDrop, deliveryCode, newDate;
            return __generator(this, function (_a) {
                currentDrop = this.state.currentDrop;
                deliveryCode = currentDrop.resource.deliveryCode;
                newDate = currentDrop.start;
                if (currentDrop) {
                    this.props.moveDrop(deliveryCode, newDate);
                }
                return [2 /*return*/];
            });
        }); };
        _this.renderBody = function (currentDrop) {
            return (React.createElement("div", { style: { marginBottom: '30px', minHeight: '500px' } },
                React.createElement(Calendar, { defaultDate: currentDrop.start, dateClick: _this.onSelectSlot, selectedText: currentDrop.title, startDate: currentDrop.resource.shippingFrom })));
        };
        return _this;
    }
    MoveDropModal.prototype.componentDidMount = function () {
        var currentDrop = this.props.currentDrop;
        this.setState({ currentDrop: currentDrop });
    };
    MoveDropModal.prototype.render = function () {
        var _this = this;
        var showDeliveryModal = this.props.showDeliveryModal;
        var currentDrop = this.state.currentDrop;
        if (!currentDrop) {
            return null;
        }
        return (React.createElement(Modal, { header: React.createElement("h4", null, "Move drop"), size: 'lg', isShowing: showDeliveryModal, hide: function () { return _this.props.hide(); }, children: this.renderBody(currentDrop), footer: (React.createElement("button", { className: "po__order-btn modal-footer__btn-center", onClick: this.moveDrop }, "Move drop")) }));
    };
    return MoveDropModal;
}(Component));
export { MoveDropModal };
//# sourceMappingURL=MoveDropModal.js.map